import { render, staticRenderFns } from "./recorder.vue?vue&type=template&id=768a5813&scoped=true&"
import script from "./recorder.vue?vue&type=script&lang=ts&"
export * from "./recorder.vue?vue&type=script&lang=ts&"
import style0 from "./recorder.vue?vue&type=style&index=0&id=768a5813&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768a5813",
  null
  
)

export default component.exports